'use strict';

var cart = require('../cart/cart');
var wishlistCart = require("./miniCartWishlist");
var quantitySelector = require('../product/quantitySelector');

var updateMiniCart = true;
var location = window.location;

const $body = $('body');
var $minicartPopOver = $('.minicart .popover');

function handleMiniCartClose(event) {
    if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0)
        || (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity'))
        || $body.hasClass('modal-open')) {
        event.stopPropagation();
        return;
    }
    $('.minicart .popover').removeClass('show');
}

function handleContinueButtonClick(event) {
    event.preventDefault();
    handleMiniCartClose({ type: 'click' });
}

/**
 * Displays the empty cart HTML in the mini cart popover.
 */
function showEmptyCart() {
    const emptyCartHtml = $('#empty-cart-html').html();
    $minicartPopOver.empty().append(emptyCartHtml);
    $minicartPopOver.addClass('show');
}

function minicartHoverIntentHandlerIn(event) {
    if ($(event.target).closest('.minicart-footer-continue-button').length) {
        return;
    }

    if ($('.search:visible').length === 0) {
        return;
    }
    var url = $('.minicart').data('action-url');
    var count = parseInt($('.minicart .minicart-quantity').text(), 10);

    if (count !== 0 && $('.minicart .popover.show').length === 0) {
        if (!updateMiniCart) {
            $minicartPopOver.addClass('show');
            return;
        }

        $minicartPopOver.addClass('show');
        $minicartPopOver.spinner().start();
        $.get(url, function (data) {
            $minicartPopOver.empty();
            $minicartPopOver.append(data);
            quantitySelector.setupInitialQuantityState($minicartPopOver);
            updateMiniCart = false;
            $.spinner().stop();
        });
    } else if (count === 0) {
        showEmptyCart();
    }
}

/**
 * Handles the click event on the mini cart.
 * Prevents navigation to the cart page if there are no products in the cart.
 * @param {Event} event - The click event triggered on the mini cart.
 */
function handleMiniCartClick(event) {
    try {
        const productQuantity = parseInt($('.minicart .minicart-quantity').text().trim());
        if (productQuantity === 0) {
            event.preventDefault();
            showEmptyCart();
        }
    }
    catch(error) {
        console.error('Error handling mini cart click:', error);
    }
}

module.exports= wishlistCart;
module.exports.customBase = function () {
    cart();
    quantitySelector.initQuantitySelector();

    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    $body.on('touchstart click', function (e) {
        if ($('.minicart').has(e.target).length <= 0) {
            $minicartPopOver.removeClass('show');
        }
    });

    $('.minicart-total').hoverIntent(minicartHoverIntentHandlerIn, function() {});

    $('.minicart').on('mouseleave focusout', function (event) {
        if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0)
            || (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity'))
            || $body.hasClass('modal-open')) {
            event.stopPropagation();
            return;
        }

        setTimeout(() => {
            // Minicart wont close if after a tiny delay, the mouse stills inside, avoiding page blinking
            if (!$('.minicart').is(':hover')) {
                $('.minicart .popover').removeClass('show');
            }
        }, 200);
    });

    $body.on('click', '.minicart-footer-continue-button', handleContinueButtonClick);

    $body.on('click', '.minicart-link', handleMiniCartClick);

    $body.on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });
    $body.on('product:afterAddToCart', function () {
        updateMiniCart = true;
    });
    $body.on('cart:update', function () {
        updateMiniCart = true;
        $minicartPopOver.spinner().stop();
    });
}